// color palette copied from https://cloudscape.design/foundation/visual-foundation/data-vis-colors/
export const colorPalette = [
    '#7d2105',
    '#3184c2',
    '#7d8998',
    '#b2911c',
    '#67a353',
    '#ba2e0f',
    '#ce567c',
    '#1c8e81',
    '#9469d6',
    '#cc5f21',
    '#273ea5',
    '#962249',
    '#03524a',
    '#6237a7',
    '#7e3103',
    '#6f062f',
    '#003e38',
    '#431d84',
    '#037f0c',
    '#602400',
    '#125502',
    '#314fbf',
    '#4d3901',
    '#a32952',
    '#06645a',
    '#6b40b2',
    '#983c02',
    '#6f5504',
    '#1f3191',
    '#780d35',
    '#01443e',
    '#4a238b',
    '#692801',
    '#5f6b7a',
    '#3759ce',
    '#b1325c',
    '#5978e3',
    '#096f64',
    '#7749bf',
    '#a84401',
    '#9c7b0b',
    '#23379b',
    '#8b1b42',
    '#014b44',
    '#59309d',
    '#732c02',
    '#1f8104',
    '#4066df',
    '#c33d69',
    '#0d7d70',
    '#8456ce',
    '#bc4d01',
];
